import { useEffect, type JSX } from 'react';
import * as React from 'react';
import dynamic from 'next/dynamic';
import { BlankLayoutStyle } from 'styled/global-style';

// Mounted so openCart() works on blank-layout pages that expose a cart CTA
// (e.g. /target). Inert until isCartOpen flips, so it costs nothing on blank
// pages that never open it. Mirrors the mount in home-layout.tsx.
const Cart = dynamic(() => import('components/pages/cart'), { ssr: false });

interface LayoutProps {
  children: JSX.Element | JSX.Element[];
}

const LayoutBlank: React.FC<LayoutProps> = ({ children }: LayoutProps) => {
  useEffect(() => {
    const siteBody = document.querySelector('body');
    siteBody?.classList.add('ready');
  });

  return (
    <>
      <BlankLayoutStyle />
      <main>{children}</main>
      <Cart />
    </>
  );
};

export default LayoutBlank;
